<template lang="pug">
  div
    //- 免单特权奖励金模块
    .free-rights-award-container(v-if="freeRightsVersion()")
      .user-award
        img.award-icon(src="https://m.hellobike.com/resource/gallery/43/DbbfiNtL_189192.png")
        span 你有{{points}}奖励金
        img.arrow-icon(@click="goExchange" src="https://m.hellobike.com/resource/helloyun/08345/MJGujh4N2B.png")
      .free-title-text.margin-bottom-12 奖励金
        span.free-brown-text 翻倍领取
      .award-content
        .free-award-item(v-for="item in freeAwardList" @click="item.clickFunc")
          .pic-content(:style="{ backgroundImage: `url(${item.backgroundImg})` }")
            .coin-num(v-if="item.num")
              img(src="https://assets.51downapp.cn/file-1754966843390-636316807.png")
              .num +{{item.num}}
          .award-text {{item.text}}
          .award-btn(:class="item.class") {{item.buttonText}}
    //- 旧版本
    .award-block-new-container(v-else-if="!isNewVersion")
      .award-block-top
        .award-top-left
          .title-img-div
          span.award-title 奖励金专享
          .award-all
            span 当前
            span.red-font {{points}}
            span 个
        .award-top-right(v-if="!env.isWechatMini")
          .award-exchange(@click="goExchange")
            img.btn(:src="ExchangeBtnImg")
      .award-block-middle
        .award-block-middle-left
          .left-top 单单返奖励金
          .have-award(v-if="awardList.length>0")
            .award-list
              .award-item(v-for="(item,index) in awardNoList")
                .award-num(@click="getAll") {{item.offerWorth}}
                .award-biz {{item.marketPlanDesc}}
            .award-button(@click="getAll()") 全部领取
          .go-award(v-else-if="rewardTaskGuidanceList.length>0&&env.isEasyBikeApp")
            .award-list
              .award-item(v-for="(item,index) in rewardTaskGuidanceList")
                .award-num(@click="goUrl(item)") {{item.offerAmount}}
                .award-biz
                  span {{item.showName}}
                  img.award-img(:src="RightArrowIcon")
            .award-button(@click="goUrl()") 去完单
          .no-award(v-else)
            .no-award-line-one 暂无可领取的奖励金
            .no-award-line-two 去下单～
        .award-block-middle-right
          .right-top 签到领
            span.top-gary 会员翻
            span.top-red 3倍
          .sign-list
            .sign-list-item(v-for="(item,index) in signList"
            :class="signList.length<3&&index===1?'sign-list-item-bottom-big':''")
              div(v-if="signList.length>2")
                .sign-list-item-top(:class="index===0?'sign-list-item-op':''")
                  span(v-if="index!==1") {{item.num}}
                  img(v-else-if="didSignToday" :src="ToggleIcon")
                  span(v-else) {{item.num}}
                .sign-list-item-bottom(:class="index!==1?'sign-list-item-opb':''") {{item.word}}
              div(v-else)
                .sign-list-item-top()
                  img(v-if="index===0&&didSignToday" :src="ToggleIcon")
                  span(v-else) {{item.num}}
                .sign-list-item-bottom(:class="index!==0?'sign-list-item-opb':''") {{item.word}}
          .sign-btn(v-if="!todaySign" @click="goSign") 签到
          .sign-remind-btn(v-else) 明日再来
    //- 新版本 奖励金 + 签到
    .new-award(v-else-if="isNewVersion")
      .title(@click="goExchange")
        .title-text 奖励金加码
        .title-action
            .title-action-text 兑换
            .title-action-icon
      .award-container
        //- 左侧单单返
        //- 存在未领奖
        .go-receive(v-if="awardList.length>0")
          .go-receive-container
              img( class="go-receive-img" :src="UnSignCoinImg")
              .go-receive-tag-bg(v-if='waitReceiveBonusNum') {{waitReceiveBonusNum}}
              .go-receive-tag(v-if='waitReceiveBonusNum') {{waitReceiveBonusNum}}
          .go-award-info(@click="getAll()")
            .go-receive-title 会员单单返
            button(class='go-receive-btn')
              span 领奖励
        //- 已领奖待使用
        .go-award-new(v-else-if="rewardTaskGuidanceList.length>0")
          .img-container-award
            img(class="go-award-img" :src="RewardReceivedImg")
          .go-award-info(@click="env.isEasyBikeApp?goUrl():goAppToast()")
            .go-award-title 会员单单返
            button(class='go-award-btn')
              .btn-text {{env.isEasyBikeApp?'赚奖励金':'APP特权'}}
        //- 右侧奖励金话费抵扣（仅在app中显示 其他都是签到）
        .deduct-block(v-if="env.isEasyBikeApp && mobileChargeInfo.haveMobileCharge")
          img.deduct-img(
            :src="mobileChargeInfo.chargeDiscountImg"
          )
          .deduct-info
            .deduct-title {{mobileChargeInfo.bonusTitle}}
            .go-charge-btn(@click="goCharge") 去充值
        //- 右侧签到
        .sign-block(v-else)
          .img-container-sign
            img(:class="!todaySign?'sign-img':'signed-img'"
            :src="!todaySign? UnSignCoinImg: SignedCoinImg")
            //- 未签到
            .sign-tag-unsigned-style-bg(v-if="!todaySign&&bountyCountToday") {{bountyCountToday}}
            .sign-tag-unsigned(v-if="!todaySign&&bountyCountToday") {{bountyCountToday}}
            //- 已签到
            .sign-tag-signed(v-else)
          .sign-info(v-if="!todaySign" @click="goSign")
            .sign-title 签到翻3倍
            button(class='sign-btn')
              .btn-text 签到
          .sign-info(v-else)
            .sign-title 签到翻3倍
            button(class='sign-btn-signed' )
              .btn-text 明天再来
    signModal(:show.sync="showDialog" :isSign="!todaySign")
    awardTaskBlock(
      :show.sync="showTaskModal"
      :propVersion="propVersion"
      :vipRecordGuid="vipRecordGuid"
      :taskModalData="taskModalData"
    )
    //- 积分抵扣话费仅在app中显示
    ChargePopup(
      v-if="env.isEasyBikeApp && mobileChargeInfo.haveMobileCharge"
      :showChargePopup.sync="showChargePopup"
      :mobileCharge="mobileChargeInfo"
      :mobileChargeCoupon="mobileChargeCoupon"
      @click-btn="firstStatus"
      @close="showChargePopup = false"
      )
</template>
<script>
import Toast from '@/components/toast';
import { Toast as VToast } from 'vant';
import { env, Native } from '@hb/hbridge';
import config from '@/const/config';
import dayjs from 'dayjs';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getTokenAndKey,
  getNoScroll,
} from '@/utils';
import { Navigator } from '@hb/h5-navigator';
import {
  batchReceiveTaskAward,
  doSignTaskAward,
  getTaskAwardDetail,
} from '@/api/vip';
import {
  calenderList,
} from '@/utils/calender';
import { getSystemCode, getVersion } from '@/utils/systemCode';
import {
  UnSignCoinImg,
  SignedCoinImg,
  RewardReceivedImg,
  SignRewardReceivedImg,
  ExchangeBtnImg,
  RightArrowIcon,
  ToggleIcon,
} from '@/assets/imgAssets';
import { Popup } from '@hb/platformui-h5';
import signModal from './sign-block.vue';
import awardTaskBlock from './award-task-block.vue';
import ChargePopup from './new-member/charge-popup.vue';

const DEFAULT_CHARGE_IMG = '';

export default {
  components: {
    signModal,
    awardTaskBlock,
    Popup,
    ChargePopup,
  },
  props: {
    // recordTotalReceiveBonusNum: {
    //   type: String,
    //   default: '0',
    // },
    points: {
      type: String,
      default: '0',
    },
    awardList: {
      type: Array,
      default: () => [],
    },
    rewardTaskGuidanceList: {
      type: Array,
      default: () => [],
    },
    didSignToday: {
      type: Boolean,
      required: true,
    },
    bountyCountToday: {
      type: String,
      default: '',
    },
    bountyCountYesterday: {
      type: String,
      default: '',
    },
    remainDays: {
      type: String,
      default: '',
    },
    remainBountyCount: {
      type: String,
      default: '',
    },
    propVersion: {
      type: String,
      default: '',
    },
    vipRecordGuid: {
      type: String,
      default: '',
    },
    isNewVersion: {
      type: Boolean,
      default: false,
    },
    /** 待领取奖励金 */
    waitReceiveBonusNum: {
      type: Number,
      default: null,
    },
    mobileCharge: {
      type: Object,
      default: () => {},
    },
    mobileChargeCoupon: {
      type: Object,
      default: () => {},
    },
  },
  inject: ['freeRightsVersion'],
  data() {
    return {
      // signList: [1, 2, 3],
      calenderObj: calenderList[0],
      isRemain: false,
      showDialog: false,
      todaySign: null,
      env,
      total: null,
      timer: null,
      hasPermission: null,
      version: '',
      taskModalData: {},
      showTaskModal: false,
      UnSignCoinImg,
      SignedCoinImg,
      RewardReceivedImg,
      SignRewardReceivedImg,
      ExchangeBtnImg,
      RightArrowIcon,
      ToggleIcon,
      operator: false,
      showChargePopup: false,
      DEFAULT_CHARGE_IMG,
    };
  },
  computed: {
    mobileChargeInfo() {
      // 是否有话费充值信息
      const haveMobileCharge = this.mobileCharge && Object.keys(this.mobileCharge).length > 0;
      const {
        rewardDeduction = 0,
        rewardDeductionSum = 0,
        usedRewardDeduction = 0,
        chargeDiscountImg = DEFAULT_CHARGE_IMG,
        rewardDeductionText = '',
        chargeRecords = [],
        redirectUrl = 'https://m.hellobike.com/AppFinanceRechargeH5/latest/index.html#/login?backUrl=https%3A%2F%2Fm.hellobike.com%2FAppFinanceRechargeH5%2Flatest%2Findex.html%3FhiddenNavigationBar%3D1%23%2Fhome',
        bonusTitle = '奖励金抵话费',
        mobileOperator = false,
      } = this.mobileCharge || {};

      return {
        haveMobileCharge,
        rewardDeduction,
        rewardDeductionSum,
        usedRewardDeduction,
        chargeDiscountImg,
        rewardDeductionText,
        chargeRecords,
        redirectUrl,
        bonusTitle,
        mobileOperator,
      };
    },
    awardNoList() {
      return this.awardList.filter((i) => dayjs(i.expiredTime).valueOf() > new Date().getTime());
    },
    signList() {
      if (this.bountyCountYesterday) {
        return [{ num: this.bountyCountYesterday, word: '已翻倍' }, { num: this.bountyCountToday, word: '今日' }, { num: this.remainBountyCount, word: `再签${this.remainDays}天` }];
      }
      return [{ num: this.bountyCountToday, word: '今日' }, { num: this.remainBountyCount, word: `再签${this.remainDays}天` }];
    },
    freeAwardList() {
      // 签到模块
      const signDisplay = {
        backgroundImg: !this.todaySign ? 'https://assets.51downapp.cn/file-1754978689125-31476792.png' : 'https://m.hellobike.com/helloyun3/22042/8850gd17_3122.png',
        num: !this.todaySign && this.bountyCountToday,
        text: '每日签到领',
        buttonText: !this.todaySign ? '3倍领取' : '明天来',
        class: !this.todaySign ? '' : 'signed',
        clickFunc: !this.todaySign ? this.goSign : () => {},
      };
      // 出行奖励金模块
      const awardDisplay = {
        backgroundImg: this.awardList && this.awardList.length ? 'https://assets.51downapp.cn/file-1754978689125-31476792.png' : 'https://m.hellobike.com/helloyun3/22042/9ym5n9ag_231.png',
        num: !!this.awardList && this.awardList.length && this.waitReceiveBonusNum,
        text: '出行完单领',
        buttonText: !(this.awardList && this.awardList.length) && this.rewardTaskGuidanceList ? '去赚币' : '2倍领取',
        class: !(this.awardList && this.awardList.length) && this.rewardTaskGuidanceList ? 'earn-award' : '',
        clickFunc: this.awardList && this.awardList.length ? this.getAll : this.clickAwardButton,
      };
      // 话费抵扣
      const bountyDisplay = env.isEasyBikeApp && this.mobileChargeInfo.haveMobileCharge ? {
        backgroundImg: 'https://m.hellobike.com/e2cc511c_miandantequantubiao.png',
        num: 0,
        text: '话费抵扣',
        buttonText: '去充值',
        class: '',
        clickFunc: this.goCharge,
      } : {
        backgroundImg: 'https://m.hellobike.com/helloyun3/22042/qoexftoo_2123.png',
        num: 0,
        text: '0元兑好物',
        buttonText: '去兑换',
        class: '',
        clickFunc: this.goExchange,
      };
      return [signDisplay, awardDisplay, bountyDisplay];
    },
  },
  watch: {
    didSignToday(val) {
      this.todaySign = val;
    },
  },
  async created() {
    this.version = await getVersion();
    this.todaySign = this.didSignToday;
    if (!this.todaySign) {
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_qiandao_click',
        contentId: 'platform_qiandao_click',
        exposureTimes: 1,
        businessInfo: {},
      });
    }
  },
  mounted() {
    // this.checkRemain();
  },
  destroyed() {
    this.timer = null;
  },
  methods: {
    clickAwardButton() {
      if (env.isEasyBikeApp) {
        this.goUrl();
      } else {
        this.goAppToast();
      }
    },
    showBtn() {
      if (!env.isEasyBikeApp) {
        return false;
      } if (env.isIOS && this.version < '6.65') {
        return false;
      }
      return true;
    },
    async goSign() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_qiandao_click',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndKey();
      try {
        const res = await doSignTaskAward({
          systemCode: getSystemCode(),
          token,
        });
        if (res.data) {
          if (res.data.repeatSignDesc) {
            Toast.show(res.data.repeatSignDesc);
            this.todaySign = true;
          } else if (res.data.didSignToday) {
            this.todaySign = true;
            this.total = this.bountyCountToday;
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_qiandaochenggong',
              contentId: 'platform_qiandaochenggong',
              exposureTimes: 1,
              businessInfo: {},
            });
            if (!this.isNewVersion && !this.freeRightsVersion()) {
              this.showDialog = true;
            } else {
              this.showRewardToast(true);
            }
          } else {
            this.todaySign = false;
            if (!this.isNewVersion && !this.freeRightsVersion()) {
              this.showDialog = true;
            } else {
              this.showRewardToast(true);
            }
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_qiandaochenggong',
              contentId: 'platform_qiandaochenggong',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
        }
        this.$emit('refresh');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    async checkRemain() {
      const version = await getVersion();
      const isLogin = await Native.isLogin();
      if (version >= '6.46.0' && isLogin && env.isEasyBikeApp) {
        try {
          const res = await Native.callNative({
            classMap: 'message/subscribe',
            method: 'msg_hasCalendarPermission',
            params: {},
            timeout: false,
          });
          if (res.hasPermission) {
            this.hasPermission = true;
            this.check();
          } else if (env.isIOS) {
            await Native.callNative({
              classMap: 'message/subscribe',
              method: 'msg_isCalendarScheduleExist',
              params: {
                title: this.calenderObj.title,
                startTime: this.calenderObj.startTime,
                endTime: this.calenderObj.endTime,
              },
              timeout: false,
            });
            this.hasPermission = true;
          } else {
            this.hasPermission = false;
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          this.hasPermission = false;
        }
      }
    },
    async goAppToast() {
      Toast.show('去哈啰App可享会员单单返特权');
    },
    async goUrl(item) {
      // 100 多业务线完单唤起浮层
      if (item && item.businessType && item.businessType !== 100) {
        Navigator.go(item.jumpUrl);
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_zhuanjinbi',
          categoryId: 'platform',
          businessInfo: {
            businessType: item.showName,
          },
        });
      } else {
        const { token } = await getTokenAndKey();
        try {
          const res = await getTaskAwardDetail({
            token,
            vipRecordId: this.vipRecordGuid,
            appCode: 'platform',
            propVersion: this.propVersion,
            goodsType: 1, // 30天
          });
          if (res.data) {
            this.taskModalData = res.data;
            getNoScroll(true);
            this.showTaskModal = true;
          } else if (this.rewardTaskGuidanceList[0]) {
            UBT.clickButton({
              pageId: 'platform_openedcard_page',
              buttonName: 'platform_zhuanjinbi',
              categoryId: 'platform',
              businessInfo: {
                businessType: this.rewardTaskGuidanceList[0].showName,
              },
            });
            Navigator.go(this.rewardTaskGuidanceList[0].jumpUrl);
          }
        } catch {
          if (this.rewardTaskGuidanceList[0]) {
            UBT.clickButton({
              pageId: 'platform_openedcard_page',
              buttonName: 'platform_zhuanjinbi',
              categoryId: 'platform',
              businessInfo: {
                businessType: this.rewardTaskGuidanceList[0].showName,
              },
            });
            Navigator.go(this.rewardTaskGuidanceList[0].jumpUrl);
          }
        }
      }
    },
    /** 奖励弹窗
     * @signed 领取奖励金
    */
    showRewardToast(signed = false, closeCb) {
      // 单单返没有金额 || 签到没有金额
      if ((!this.waitReceiveBonusNum && !signed)
        || (!this.bountyCountToday && signed)) {
        return null;
      }
      // 签到
      const signedDom = `<div style="display:flex;align-items:center;flex-direction:column;">
                  <div>签到翻倍成功</div>
                  <div style="display:flex;align-items:center">
                    <span>奖励金</span>
                    <img
                      style="height:0.16rem;width:0.16rem;margin:0 0.02rem"
                      src=${UnSignCoinImg}>
                    <span>+${this.bountyCountToday}</span>
                  </div>
                </div> `;
      // 单单返
      const unsignedDom = `<div style="display:flex;align-items:center;">
                  <span>奖励金</span>
                  <img
                    style="height:0.16rem;width:0.16rem;margin:0 0.02rem"
                    src=${UnSignCoinImg}>
                  <span>+${this.waitReceiveBonusNum}</span>
                </div> `;
      VToast(
        {
          type: 'html',
          message: signed ? signedDom : unsignedDom,
          className: 'custom-toast-award',
          duration: 2000,
          onClose() {
            if (closeCb) {
              closeCb();
            }
          },
        },
      );
      return null;
    },
    goExchange() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_exchange',
        categoryId: 'platform',
        businessInfo: {},
      });
      const link = `https://m.hellobike.com/AppPlatformH5/${config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html#/bounty?adsource=dandanfan`;
      Navigator.go(link);
    },
    async getAll() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_order_return',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.total = this.awardNoList.reduce((acc, cur) => acc + cur.offerWorth, 0);
      const { token } = await getTokenAndKey();
      try {
        const res = await batchReceiveTaskAward({
          token,
          channelId: env.platformCode,
          systemCode: getSystemCode(),
          infos: this.awardNoList,
        });
        if (res) {
          if (!this.isNewVersion) {
            this.timer = setTimeout(() => {
              this.$emit('refresh', this.awardNoList);
            }, 1000);
          }
          /** 唤起任务弹窗 */
          if (this.isNewVersion || this.freeRightsVersion()) {
            this.showRewardToast(false, () => {
              // 等toast结束执行
              this.timer = setTimeout(() => {
                this.$emit('refresh', this.awardNoList);
              }, 1000);
            });
            this.goUrl();
          }
        }
      } catch (e) {
        Toast.show(e || '领取失败');
      }
    },
    goCharge() {
      const { mobileOperator, redirectUrl } = this.mobileChargeInfo;
      // 运营商直接跳转
      if (mobileOperator) {
        Navigator.go(redirectUrl);
      } else {
        this.showChargePopup = true;
      }
    },
    firstStatus(val) {
      this.$emit('click-btn', val);
    },
  },
};

</script>
<style lang="less" scoped>
@import '../../../../styles/index.less';
@import '../style.less';

.award-block-new-container {
  height: 2.15rem;
  background: #fff;
  border-radius: 0.16rem;
  margin: 0 0.12rem 0.08rem 0.12rem;
  margin-top: -0.8rem;

  .award-block-top {
    padding: 0.14rem 0.14rem 0 0.12rem;
    display: flex;
    justify-content: space-between;

    .award-top-left {
      display: flex;

      .title-img-div {
        padding-top: 0.04rem;

        .title-img {
          align-items: center;
          width: 0.17rem;
          height: 0.17rem;
          margin-right: 0.04rem;
          margin-top: -0.02rem;
        }
      }

      .award-title {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 600;
        color: #242729;
        line-height: 0.22rem;
      }

      .award-all {
        margin-left: 0.08rem;
        font-size: 0.13rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #242729;
        line-height: 0.18rem;
        margin-top: 0.03rem;
        position: relative;

        .red-font {
          margin-left: 0.02rem;
          font-size: 0.16rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: 900;
          color: #fa4614;
          line-height: 0.16rem;
        }

        .award-new {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          width: 0.37rem;
          height: 0.2rem;
          background: #ffd575;
          border-radius: 0.12rem 0.12rem 12px 0;
          border: 0.01rem solid #fff;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.12rem;
          color: #7d3b2a;
          line-height: 0.2rem;
          text-align: center;
        }
      }
    }

    .award-top-right {
      display: flex;

      .award-all {
        font-size: 0.13rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #531900;
        line-height: 0.18rem;
        margin-right: 0.08rem;

        .red-font {
          margin-left: 0.02rem;
          font-size: 0.16rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: 600;
          color: #fa4614;
          line-height: 0.22rem;
        }
      }

      .award-exchange {
        img.btn {
          width: 0.47rem;
          height: 0.21rem;
        }
      }
    }
  }

  .award-block-middle {
    padding: 0 0.12rem;
    margin-top: 0.06rem;
    display: flex;
    justify-content: space-between;

    .award-block-middle-left {
      width: 1.58rem;
      height: 1.55rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/5ResD_bg.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      padding: 0.14rem 0.14rem;

      .left-top {
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.14rem;
        color: #242729;
        line-height: 0.16rem;
        font-style: normal;
      }

      .have-award {
        .award-list {
          overflow: scroll;
          display: flex;
          width: 100%;
          margin-top: 0.1rem;

          &::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
            color: transparent;
          }

          .award-item {
            width: 0.6rem;
            flex-shrink: 0;

            .award-num {
              background-image: url(https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png);
              background-size: 100% 100%;
              width: 0.38rem;
              height: 0.38rem;
              font-size: 0.13rem;
              font-family: DINAlternate-Bold, DINAlternate, sans-serif;
              font-weight: bold;
              color: #a36a01;
              line-height: 0.38rem;
              text-align: center;
              margin: 0 auto;
            }

            .award-biz {
              text-align: center;
              font-size: 0.12rem;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #5a6066;
              width: 0.38rem;
              margin: 0 auto;
            }

            .award-day {
              width: 0.6rem;
              text-align: center;
              font-size: 0.11rem;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: rgba(83, 25, 0, 0.5);
            }
          }
        }

        .award-button {
          margin-top: 0.18rem;
          width: 1.26rem;
          height: 0.32rem;
          border-radius: 0.16rem;
          border: 0.01rem solid #fb7c59;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.14rem;
          color: #fa4614;
          line-height: 0.3rem;
          text-align: center;
        }
      }

      .go-award {
        .award-list {
          overflow: scroll;
          display: flex;
          width: 100%;
          margin-top: 0.1rem;

          &::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
            color: transparent;
          }

          .award-item {
            width: 0.6rem;
            flex-shrink: 0;

            .award-num {
              background-image: url(https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png);
              background-size: 100% 100%;
              width: 0.38rem;
              height: 0.38rem;
              font-size: 0.13rem;
              font-family: DINAlternate-Bold, DINAlternate, sans-serif;
              font-weight: bold;
              color: #7d3b2a;
              line-height: 0.38rem;
              text-align: center;
              margin: 0 auto;
            }

            .award-biz {
              text-align: center;
              font-size: 0.12rem;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #5a6066;

              img.award-img {
                width: 0.07rem;
                height: 0.07rem;
                margin-top: 0.03rem;
                margin-left: 0.01rem;
              }
            }

            .award-day {
              width: 0.6rem;
              text-align: center;
              font-size: 0.11rem;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: rgba(83, 25, 0, 0.5);
            }
          }
        }

        .award-button {
          margin-top: 0.18rem;
          width: 1.26rem;
          height: 0.32rem;
          border-radius: 0.16rem;
          border: 0.01rem solid #fb7c59;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.14rem;
          color: #fa4614;
          line-height: 0.3rem;
          text-align: center;
        }
      }

      .no-award {
        margin-top: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.13rem;
        color: #879099;

        .no-award-line-two {
          color: #242729;
        }
      }
    }

    .award-block-middle-right {
      width: 1.58rem;
      height: 1.55rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/K1_T9_2.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;

      .right-top {
        padding: 0.14rem 0.14rem 0 0.12rem;
        color: #242729;
        line-height: 0.16rem;
        font-style: normal;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.14rem;

        span.top-gary {
          margin-left: 0.05rem;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          color: #5a6066;
          line-height: 0.16rem;
        }

        span.top-red {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          color: #fa4614;
        }
      }

      .sign-list {
        margin-top: 0.11rem;
        display: flex;
        padding: 0 0.12rem;
        justify-content: space-between;

        .sign-list-item {
          width: 0.42rem;
          height: 0.58rem;
          background: #fff;
          border-radius: 0.06rem;

          .sign-list-item-top {
            padding-top: 0.09rem;
            font-family: DINAlternate, sans-serif;
            font-weight: bold;
            font-size: 0.14rem;
            color: #7d3b2a;
            text-align: center;
            overflow: hidden;

            img {
              margin-top: -0.06rem;
              margin-bottom: -0.04rem;
              width: 0.22rem;
              height: 0.22rem;
            }
          }

          .sign-list-item-op {
            opacity: 0.5;
            font-weight: 400;
          }

          .sign-list-item-bottom {
            margin-top: 0.06rem;
            font-family: DINAlternate, sans-serif;
            font-weight: bold;
            font-size: 0.11rem;
            color: #7d3b2a;
            text-align: center;
          }

          .sign-list-item-opb {
            opacity: 0.5;
            font-weight: 400;
            font-family: PingFangSC, PingFang SC, sans-serif;
          }
        }

        .sign-list-item-bottom-big {
          width: 0.88rem;
          height: 0.58rem;
          background: #fff;
          border-radius: 0.06rem;
        }
      }

      .sign-btn {
        width: 1.26rem;
        height: 0.32rem;
        border-radius: 0.16rem;
        border: 0.01rem solid #deb1a5;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.14rem;
        color: #7d3b2a;
        line-height: 0.3rem;
        text-align: center;
        margin: 0.13rem auto 0 auto;
      }

      .sign-remind-btn {
        width: 1.26rem;
        height: 0.32rem;
        border-radius: 0.16rem;
        border: 1px solid #d3dae0;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.14rem;
        color: #879099;
        line-height: 0.3rem;
        text-align: center;
        margin: 0.13rem auto 0 auto;
      }
    }
  }
}

.new-award {
  border-radius: 0.14rem;
  background: linear-gradient(to bottom, rgba(255, 246, 211, 1) 0%, rgba(255, 255, 255, 1) 100%);
  width: 100%;
  height: 100%;

  .title {
    padding: 0.09rem 0.08rem 0.04rem 0.1rem;
    display: flex;
    font-size: 0.14rem;
    font-weight: 400;
    color: rgba(97, 93, 69, 1);
    font-family: DouyinSans, sans-serif;
    align-items: center;

    .title-text {
      flex: 1;
      background: linear-gradient(to right, rgba(91, 86, 59, 1), rgba(69, 66, 54, 1));
      background-clip: text;
      color: transparent;
      font-weight: 500;
    }

    .title-action {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .title-action-text {
        font-size: 0.12rem;
        font-weight: 500;
        color: #5a6066;
        line-height: normal;
      }

      .title-action-icon {
        width: 0.12rem;
        height: 0.12rem;
        background-image: url('https://m.hellobike.com/resource/helloyun/08345/MJGujh4N2B.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-top: 0.01rem;
      }
    }
  }

  .common-title {
    font-size: 0.11rem;
    color: #242729;
    font-family: PingFang SC, sans-serif;
    font-weight: 600;
    line-height: 0.15rem;
    max-width: 0.73rem;
    .ellipsis();
  }

  .common-img {
    width: 0.51rem;
    height: 0.36rem;
    margin-bottom: 0.03rem;
  }

  .common-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0.06rem;
    max-width: 0.73rem;
  }

  .common-btn() {
    border-radius: 0.06rem;
    display: flex;
    overflow: hidden;
    text-overflow: clip;
    margin-top: 0.06rem;
    min-width: 0.6rem;
    max-width: 0.73rem;
    height: 0.22rem;
    gap: 0.01rem;
    color: #fff;
    font-size: 0.12rem;
    font-weight: 500;
    line-height: 1;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to right, rgba(255, 95, 93, 1), rgba(255, 78, 28, 1));
  }

  .img-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.64rem;
    height: 0.64rem;
    background-color: #fff;
    border-radius: 0.08rem;
    margin: 0 auto;
    position: relative;
  }

  .btn-text {
    .ellipsis();
  }

  .award-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0.1rem;

    .award-block {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .go-award-info {
      .common-info();
    }

    .go-receive {
      display: flex;
      flex-direction: column;
      align-items: center;

      .go-receive-container {
        .img-container();
      }

      .go-receive-img {
        .common-img();

        width: 0.38rem;
        height: 0.38rem;
        position: relative;
      }

      .go-receive-tag {
        .sign-tag-common();

        text-shadow: 0 -0.02rem 0 #fff, 0 0.01rem 0 #fff;
        z-index: 1;

        &::before {
          content: "+";
          font-weight: 700;
        }
      }

      .go-receive-tag-bg {
        .sign-tag-common();

        -webkit-text-stroke: 3px #fff;

        &::before {
          content: "+";
          font-weight: 700;
        }
      }

      .go-receive-title {
        .common-title();
      }

      .go-receive-btn {
        .common-btn();
      }
    }

    .go-award-new {
      display: flex;
      flex-direction: column;
      align-items: center;

      .img-container-award {
        .img-container();

        padding-top: 0;
      }

      .go-award-img {
        .common-img();

        width: 0.64rem;
        height: 0.64rem;
      }

      .go-award-title {
        .common-title();
      }

      .go-award-btn {
        .common-btn();

        background: #fff;
        border: 0.01rem rgba(255, 79, 31, 1) solid;
        color: rgba(255, 79, 31, 1);
      }
    }

    .sign-tag-common {
      display: flex;
      align-items: center;
      font-family: "DIN Alternate Bold", sans-serif, Arial;
      font-weight: 700;
      color: rgba(153, 98, 1, 1);
      position: absolute;
      bottom: 0;
    }

    .sign-block {
      display: flex;
      flex-direction: column;
      align-items: center;

      .img-container-sign {
        .img-container();

        border-radius: 0.08rem;
        margin: 0 auto;
        position: relative;
        justify-content: center;
        align-items: center;

        .sign-tag-unsigned {
          .sign-tag-common();

          text-shadow: 0 -0.02rem 0 #fff, 0 0.01rem 0 #fff;
          z-index: 1;

          &::before {
            content: "+";
            font-weight: 700;
          }
        }

        .sign-tag-unsigned-style-bg {
          .sign-tag-common();

          -webkit-text-stroke: 3px #fff;

          &::before {
            content: "+";
            font-weight: 700;
          }
        }

        .sign-tag-signed {
          position: absolute;
          bottom: 0;
          right: 0.01rem;
          // background-color: #879099;
          background: url("https://m.hellobike.com/resource/gallery/59/BxRU7z1U_Group%201707483245.png?x-oss-process=image/quality,q_80");
          background-repeat: no-repeat;
          background-size: cover;
          width: 0.24rem;
          height: 0.14rem;
        }
      }

      .sign-img {
        .common-img();

        height: 0.38rem;
        width: 0.38rem;
        position: relative;
      }

      .signed-img {
        .common-img();

        height: 0.31rem;
        width: 0.45rem;
        position: relative;
      }

      .sign-info {
        .common-info();
      }

      .sign-title {
        .common-title();
      }

      .sign-btn {
        .common-btn();
      }

      .sign-btn-signed {
        .common-btn();

        background: rgba(188, 196, 204, 1);
      }
    }

    .deduct-block {
      display: flex;
      flex-direction: column;
      align-items: center;

      .deduct-img {
        .img-container();

        margin: 0 auto;
        justify-content: center;
        align-items: center;
      }

      .deduct-info {
        .common-info();

        .deduct-title {
          .common-title();
        }

        .go-charge-btn {
          .common-btn();
        }
      }
    }
  }
}

.free-rights-award-container {
  margin: 0 0.08rem 0.08rem;
  padding: 0.12rem 0.16rem 0.16rem;
  position: relative;
  height: 1.8rem;
  background: #fff;
  border-radius: 0.16rem;

  .free-title-text {
    margin-bottom: 0.12rem;
    margin-left: 0.02rem;
  }

  .title-pic {
    height: 0.22rem;
    object-fit: contain;
    margin-bottom: 0.12rem;
  }

  .award-content {
    display: flex;
    justify-content: space-between;

    .free-award-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .pic-content {
        width: 1.02rem;
        height: 0.6rem;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: top;

        .coin-num {
          width: 0.38rem;
          margin: 0.1rem auto;
          animation: float 2s ease-in-out infinite;

          img {
            width: 0.38rem;
            height: 0.38rem;
          }

          .num {
            margin-top: -0.1rem;
            height: 0.2rem;
            line-height: 0.2rem;
            color: #996201;
            text-align: center;
            font-family: DINAlternate, sans-serif;
            font-size: 0.2rem;
            font-weight: 700;
            // -webkit-text-stroke: 0.014rem #fff; /* 宽度和颜色 */
            // 由于stroke不是外部描边，会使文字变细，所以用以下方法
            text-shadow:
              0 0 0.02rem #fff, /* 描边颜色（黑色） */
              0 0 0.02rem #fff,
              0 0 0.02rem #fff,
              0 0 0.02rem #fff; /* 多个方向叠加 */
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(-0.05rem);
          }

          50% {
            transform: translateY(0);
          }
        }
      }

      .award-text {
        margin-top: 0.095rem;
        height: 0.18rem;
        line-height: 0.18rem;
        color: #000;
        text-align: center;
        font-family: "PingFang SC", sans-serif;
        font-size: 0.13rem;
        font-weight: 500;
      }

      .award-btn {
        margin-top: 0.065rem;
        text-align: center;
        width: 0.6rem;
        height: 0.24rem;
        border-radius: 0.24rem;
        background: linear-gradient(90deg, rgba(253, 225, 197, 0.92) 2.77%, #ffd2a5 99.97%);
        color: #6b0d00;
        font-family: "PingFang SC", sans-serif;
        font-size: 0.12rem;
        font-weight: 500;
        line-height: 0.24rem;

        &.signed {
          background: #e1e6eb;
          color: #6f6f6f;
        }

        &.earn-award {
          color: #6b0d00;
          background: #fff;
          border: 0.01rem solid #6b0d00;
        }
      }
    }
  }

  .user-award {
    position: absolute;
    top: 0.13rem;
    right: 0.155rem;
    height: 0.24rem;
    border-radius: 0.1rem;
    background:
      radial-gradient(
        circle at center,
        #fff2d0 0%,
        rgba(255, 255, 255, 0) 80%
      );
    display: flex;
    color: #242729;
    font-family: DINAlternate, sans-serif;
    font-size: 0.11rem;
    font-weight: 500;
    line-height: 0.24rem;
    align-items: center;

    .award-icon {
      width: 0.14rem;
      height: 0.14rem;
      margin-right: 0.04rem;
    }

    .arrow-icon {
      width: 0.11rem;
      height: 0.11rem;
    }
  }
}
</style>
